import {useState} from "react";
import {useQueryClient} from "react-query";
import {useNavigate, useParams} from "react-router-dom";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";

import * as dangerEvaluationCheckItem from "../../api/permissionApi/dangerEvaluationCheckItem";
import {useGetQuery, useRemoveMutation} from "../../hooks/useQueryHooks";
import {ResponseList, ResponseRemove} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {initialDepartmentListParams} from "../../models/serverModels/EQDepartment";

import BusinessIcon from "@mui/icons-material/Business";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from "@mui/material";
import {alertStateAtom} from "../../Recoil/Atom/AlertAtom";
import MWSkeleton from "../../components/MWSkeleton";
import SubTitle from "../../components/SubTitle";
import {WPCheckItem} from "../../models/serverModels/permission/WPCheckItem";
import {CategoryNames} from "../../models/serverModels/permission/WPDangerEvaluation";
import {SubMenuGroup} from "../../styledComponents/StyledListContainer";
import {StyledTableContainer, StyledTableHead} from "../../styledComponents/StyledTable";

const ListContainer = styled(Box)(({theme}) => ({
  minWidth: "1200px",
}));
const CheckItemList = () => {
  const {id} = useParams();
  const tokenState = useRecoilValue(tokenSelector);

  const [page, setPage] = useState<number>(1);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const setAlertState = useSetRecoilState(alertStateAtom);

  const {
    data: checkItemList,
    isLoading,
    isFetching,
  } = useGetQuery<ResponseList<WPCheckItem>>({
    key: ["CheckItemList", {token: tokenState, categoryIndex: parseInt(id!)}],
    api: () => dangerEvaluationCheckItem.getList({token: tokenState, categoryIndex: parseInt(id!)}),
  });

  const {mutate: removeMutate} = useRemoveMutation<ResponseRemove, Params.Remove>({
    api: dangerEvaluationCheckItem.remove,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries("CheckItemList");
      },
    },
  });

  return (
    <ListContainer>
      <SubTitle subTitle="유해위험요인 리스트" />
      <SubMenuGroup>
        <Box></Box>
        <Button
          variant="outlined"
          size="small"
          startIcon={<BusinessIcon />}
          onClick={() => {
            navigate(`/Permission/CreateCheckItem/${id}`);
          }}
        >
          추가
        </Button>
      </SubMenuGroup>
      <StyledTableContainer>
        <Table>
          <StyledTableHead>
            <TableRow>
              <TableCell align="center">#</TableCell>
              <TableCell align="center">구분</TableCell>
              <TableCell align="center">항목</TableCell>
              <TableCell align="center">표시순서</TableCell>
              <TableCell align="center" width="15%">
                편집
              </TableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {isLoading && isFetching ? (
              <MWSkeleton row={12} column={5} />
            ) : (
              checkItemList?.items.map((item, index) => (
                <TableRow key={item.uid}>
                  <TableCell align="center">
                    {page === 1
                      ? index + 1
                      : (page - 1) * initialDepartmentListParams.rows! + index + 1}
                  </TableCell>
                  <TableCell align="center">{CategoryNames[item.categoryIndex]}</TableCell>
                  <TableCell align="center">{item.name}</TableCell>
                  <TableCell align="center">{item.displayOrder}</TableCell>

                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      style={{marginRight: "12px"}}
                      onClick={() => {
                        navigate(`/Permission/EditCheckItem/${item.uid}`);
                      }}
                    >
                      편집
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={() => {
                        setAlertState({
                          toggle: true,
                          message: "등록된 아이템를 삭제하시겠습니까?",
                          execution: () => removeMutate({token: tokenState, id: item.uid!}),
                        });
                      }}
                    >
                      삭제
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </ListContainer>
  );
};

export default CheckItemList;
